import { render, staticRenderFns } from "./result_sentence.vue?vue&type=template&id=b726a6de&scoped=true&"
import script from "./result_sentence.vue?vue&type=script&lang=js&"
export * from "./result_sentence.vue?vue&type=script&lang=js&"
import style0 from "./result_sentence.vue?vue&type=style&index=0&id=b726a6de&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b726a6de",
  null
  
)

export default component.exports